import React from "react";
import PropTypes from "prop-types";
import { header } from "./element";

const HeaderText = ({ headerText, showTitle }) => (
  <div>
    {" "}
    {showTitle ? (
      <div>
        <h1 style={header}>{headerText}</h1>
      </div>
    ) : null}
  </div>
);

HeaderText.propTypes = {
  headerText: PropTypes.any,
  showTitle: PropTypes.bool,
};

export default HeaderText;
